module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "mu-clock-number",
    class: _vm.numberClass,
    style: (_vm.numberStyle)
  }, [_vm._v(_vm._s(_vm.value === 0 ? '00' : _vm.value))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ba91db9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/timePicker/clockNumber.vue
// module id = 418
// module chunks = 1